import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/features/auth/auth-provider";
import { resolveGetStartedDestination } from "@/features/marketing/resolve-get-started-destination";

/**
 * Marketing Get Started entry.
 * Already-authenticated users go straight to their post-login destination;
 * everyone else is sent to /get-started so login cannot leave the landing CTA stuck busy.
 */
export function useGetStarted() {
  const navigate = useNavigate();
  const { ready, authenticated, serverAuthenticated, redirectTo } = useAuth();

  const startGetStarted = useCallback(() => {
    if (!ready) return;

    if (authenticated && serverAuthenticated && redirectTo) {
      navigate(resolveGetStartedDestination(redirectTo), { replace: true });
      return;
    }

    navigate("/get-started");
  }, [ready, authenticated, serverAuthenticated, redirectTo, navigate]);

  return {
    startGetStarted,
    busy: !ready,
  };
}
